import type { ReactElement } from 'react'

interface Props {
  eyebrow?: string
  title: string
  subtitle?: string
  align?: 'left' | 'center'
}

export default function SectionHeader({ eyebrow, title, subtitle, align = 'center' }: Props): ReactElement {
  return (
    <div className={`section-header text-${align}`}>
      {eyebrow && <div className="text-uppercase small fw-semibold text-success mb-2">{eyebrow}</div>}
      <h2>{title}</h2>
      {subtitle && <p className="lead">{subtitle}</p>}
    </div>
  )
}
